import { styled } from "@mui/material";
import React from "react";

interface IndicatorIconProps {
  children?: React.ReactNode;
  role: "progressbar";
}

export const IndicatorIcon = styled(
  "div",
  {}
)<IndicatorIconProps>(() => ({
  role: "progressbar",
  backgroundColor: "inherit",
  display: "flex",
  alignItems: "center",
  alignContent: "center",
  justifyContent: "center",
})) as React.ComponentType<IndicatorIconProps>;
